import type { DynamicComponentsComponent } from "../../types";

/** Placeholder renderer for dynamic component injection. */
export function DynamicComponentsRenderer({ component }: { component: DynamicComponentsComponent }) {
  const variableKey = component?.content?.variableKey ?? "components";
  const count = Array.isArray(component?.content?.components) ? component.content.components.length : 0;
  return (
    <div className="rounded-xl border border-dashed border-slate-300 bg-slate-50 px-4 py-3 text-sm xl:text-base text-slate-600">
      Dynamic components placeholder ({`{${variableKey}}`})
      {count > 0 ? ` – ${count} component(s) ready to inject.` : " – No components assigned yet."}
    </div>
  );
}
